import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import HorizontalList from 'components/HorizontalList';

export const StyledPageLayout = styled.div`
  padding-left: ${scaleSize(220)}px;
`;

export const StyledCollection = styled.div`
  position: relative;
  top: ${scaleSize(55)}px;
  width: 100%;
`;

export const StyledCollectionWrapper = styled.div.attrs(({ offset }) => {
  return {
    style: {
      transform: `translate3d(0, -${scaleSize(offset)}px, 0)`,
    },
  };
})`
  position: relative;
`;

export const StyledCollectionTitle = styled.div.attrs(({ offset }) => {
  return {
    style: {
      transform: `translate3d(0, -${scaleSize(offset)}px, 0)`,
    },
  };
})`
  position: relative;
  color: ${({ theme }) => theme.defaultColor};
  font-size: ${scaleSize(72)}px;
  line-height: ${scaleSize(72)}px;
  font-family: RobotoBold, sans-serif;
`;

export const StyledListTitle = styled.div`
  height: ${scaleSize(120)}px;
  box-sizing: border-box;
  padding-bottom: ${scaleSize(35)}px;
  padding-top: ${scaleSize(40)}px;
  font-weight: 500;
  font-size: ${scaleSize(40)}px;
  line-height: 1.2;
  letter-spacing: normal;
  color: ${({ theme }) => theme.defaultColor};
  font-family: RobotoMedium, sans-serif;
`;

export const StyledHorizontalList = styled(HorizontalList)`
  height: ${scaleSize(630)}px;
  transform: translateY(${({ extraOffset }) => extraOffset || 0}px);
  margin-top: ${scaleSize(5)}px;
  position: relative;
  white-space: nowrap;
`;
